<template>
  <v-dialog :fullscreen="($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)" v-model="dialog" width="450px">
    <v-card>
      <div style="width: 98%; padding-top: 2%; position: absolute; position: absolute">
        <v-icon color="grey" size="20" style="float: right; cursor: pointer" @click="close">mdi-close</v-icon>
      </div>
      <div style="padding: 30px 10px; text-align: center">
        <p style="margin-bottom: 40px">
          <slot></slot>
        </p>
        <v-btn class="accept white--text" x-large width="200px" @click="close">
          OK
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['dialog'],
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
